import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button
} from "@mui/material"


const ProjectDelete = ({ rowData, mainProps }) => {



  return (
    <Box>
      <Button
        variant="contained"
        color="warning"
        size="small"
        onClick={async () => {
            const { onDeleteGasProject } = mainProps
            if(window.confirm("بعد از تایید پرونده حذف و مبلغ پیش ثبت نام پرونده به کیف پول برگشت داده میشود!!")){
                await onDeleteGasProject(rowData.row.id)
            }
           
        }}
      >
        حذف
      </Button>
    </Box>
  )
}

export default ProjectDelete
